import React from 'react';
import { styled } from '@linaria/react';
import { BottomSheet } from '@daedalus/atlas/BottomSheet';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { PopUp } from '@daedalus/atlas/PopUp';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getRefundType, RefundType } from '@daedalus/core/src/offer/business/cancellationPenalties';
import { CancellationPenalty } from '@daedalus/core/src/offer/types/offer';
import { CancellationPenalties } from '../CancellationPenalties/CancellationPenalties';
interface Props {
  currencyCode: string;
  totalPrice: number;
  cancellationPenalties: CancellationPenalty[];
  setIsCancellationPenaltiesDetailsOpen: (state: boolean) => void;
  isCancellationPenaltiesDetailsOpen: boolean;
  hotelTimeZone?: string;
  chargeableCurrencyCode?: string;
  hasChargeLaterRefundPolicy?: boolean;
  prefersReducedMotion?: boolean;
  isSplitBookingDeal?: boolean;
  isPostBooking?: boolean;
}
const CancellationPenaltiesWrapper = /*#__PURE__*/styled('div')({
  name: "CancellationPenaltiesWrapper",
  class: "c12svtir",
  propsAsIs: false
});
const CancellationPenaltiesHeader = ({
  cancellationPenalties
}: {
  cancellationPenalties: CancellationPenalty[];
}) => {
  const refundType = getRefundType(cancellationPenalties);
  if (refundType === RefundType.nonRefundable) {
    return <Text variant="titleM">
        <FormattedMessageWrapper id="cancellationPenalties.nonRefundable" defaultMessage="Non-refundable" />
      </Text>;
  }
  if (refundType === RefundType.freeCancellation) {
    return <Text variant="titleM">
        <FormattedMessageWrapper id="cancellationPenalties.freeCancellation" defaultMessage="Free cancellation" />
      </Text>;
  }
  return <Text variant="titleM">
      <FormattedMessageWrapper id="cancellationPenalties.partiallyRefundable" defaultMessage="Partially refundable" />
    </Text>;
};
export const CancellationPenaltiesPopUp = ({
  cancellationPenalties,
  currencyCode,
  chargeableCurrencyCode,
  totalPrice,
  hotelTimeZone,
  setIsCancellationPenaltiesDetailsOpen,
  isCancellationPenaltiesDetailsOpen,
  hasChargeLaterRefundPolicy,
  prefersReducedMotion,
  isSplitBookingDeal,
  isPostBooking
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  if (isMobile) {
    return <BottomSheet isOpen={isCancellationPenaltiesDetailsOpen} onClose={() => setIsCancellationPenaltiesDetailsOpen(false)} titleBarProps={{
      centerContent: <CancellationPenaltiesHeader cancellationPenalties={cancellationPenalties} />
    }} prefersReducedMotion={prefersReducedMotion}>
        <CancellationPenalties cancellationPenalties={cancellationPenalties} totalPrice={totalPrice} displayCurrencyCode={currencyCode} chargeableCurrencyCode={chargeableCurrencyCode} hotelTimeZone={hotelTimeZone} hasChargeLaterRefundPolicy={hasChargeLaterRefundPolicy} isInPopUp isSplitBookingDeal={isSplitBookingDeal} isPostBooking={isPostBooking} />
      </BottomSheet>;
  }
  return <PopUp isOpen={isCancellationPenaltiesDetailsOpen} titleBarProps={{
    centerContent: <CancellationPenaltiesHeader cancellationPenalties={cancellationPenalties} />
  }} closeAction={() => setIsCancellationPenaltiesDetailsOpen(false)} width={520}>
      <CancellationPenaltiesWrapper>
        <CancellationPenalties cancellationPenalties={cancellationPenalties} totalPrice={totalPrice} displayCurrencyCode={currencyCode} chargeableCurrencyCode={chargeableCurrencyCode} hotelTimeZone={hotelTimeZone} hasChargeLaterRefundPolicy={hasChargeLaterRefundPolicy} isSplitBookingDeal={isSplitBookingDeal} isInPopUp isPostBooking={isPostBooking} />
      </CancellationPenaltiesWrapper>
    </PopUp>;
};

require("./CancellationPenaltiesPopUp.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CancellationPenaltiesPopUp.tsx");